import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { CompensationReadApiClient, People } from '~/services/Http';

export const GET_TEAM_COMPENSATIONS_SWR_KEY =
  'CompensationReadApiClient.getTeamCompensations';

export function useGetTeamCompensations(args: {
  employeeId: string;
  lang?: string;
  offset?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
  order?: People.Order25;
  treeId?: string;
  roles?: string[];
  unitIds?: number[];
}): UseSWROutput<People.CompensationDto[]> {
  return useSWR(
    [
      GET_TEAM_COMPENSATIONS_SWR_KEY,
      args.employeeId,
      args?.lang ?? undefined,
      args?.offset ?? undefined,
      args?.limit ?? undefined,
      args?.startDate ?? undefined,
      args?.endDate ?? undefined,
      args?.order ?? undefined,
      args?.treeId ?? undefined,
      args?.unitIds ?? undefined,
      args?.roles ?? undefined,
    ],
    ([
      _swrKey,
      employeeId,
      lang,
      offset,
      limit,
      startDate,
      endDate,
      order,
      treeId,
      unitIds,
      roles,
    ]) =>
      CompensationReadApiClient.getTeamCompensations(
        employeeId,
        order,
        offset,
        limit,
        startDate,
        endDate,
        lang,
        treeId,
        roles,
        unitIds,
      ).then((r) => r.data),
  );
}
